import React from 'react'
import logoList, { companyInfo } from '../../constants/logoList'

const CLIENT = process.env.REACT_APP_CLIENT || 'woodworth'
const BRAND = process.env.REACT_APP_BRAND || 'wlink'

const ReturnInvoiceHeader = ({ returnOrder }) => (
    <>
        <div className="invoice-header-container">
            <div className="invoice-header-logo">
                <img
                    src={logoList?.[CLIENT]?.PRINT_LOGO}
                    alt="logo"
                    className="invoice-header-logo-size"
                />
            </div>
            <div className="invoice-header-name">
                <h3>{companyInfo?.[BRAND]?.COMPANY_NAME}</h3>
                <br />
                <p>{companyInfo?.[BRAND]?.COMPANY_ADDRESS}</p>
                <p>{companyInfo?.[BRAND]?.COMPANY_ADDRESS_1}</p>
                <p>{companyInfo?.[BRAND]?.COMPANY_PHONE}</p>
                <p>{companyInfo?.[BRAND]?.COMPANY_WEB_URL}</p>
                <p>{companyInfo?.[BRAND]?.COMPANY_EMAIL}</p>
            </div>

            <div className="invoice-header-invoice-no">
                <div>
                    <h2 style={{ textAlign: 'center' }}>Credit Memo</h2>
                </div>
                <br />
                <div>
                    <table
                        className="invoice-header-top-table"
                        style={{ width: '100%' }}
                    >
                        <tbody>
                            <tr className="invoice-header-top-table">
                                <td className="invoice-header-top-table">
                                    Date
                                </td>
                                <td className="invoice-header-top-table">
                                    Credit No.
                                </td>
                            </tr>
                            <tr className="invoice-header-top-table">
                                <td className="invoice-header-top-table">
                                    {returnOrder?.finishedDate}
                                </td>
                                <td className="invoice-header-top-table">
                                    {returnOrder?.returnInvoiceNumber}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div className="invoice-to-container">
            <div className="invoice-to-item">
                <div>Customer</div>
                <div className="invoice-to-details">
                    <p>{returnOrder?.company}</p>
                    <p>{returnOrder?.clientName}</p>
                    <p>
                        {returnOrder?.address}, {returnOrder?.addressLine2}
                    </p>
                    <p>
                        {returnOrder?.city}, {returnOrder?.province}{' '}
                        {returnOrder?.postCode}
                    </p>
                    <p>T: {returnOrder?.phone}</p>
                </div>
            </div>
        </div>
    </>
)

export default ReturnInvoiceHeader
